module.exports = __webpack_public_path__ + "img/2.48e394d7.jpg";